import { HttpErrorResponse } from '@angular/common/http';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { GetSessionRedirectStateV1Response } from '@arc/unified-payments-frontend/shared-payment';

export const HostedPaymentsPadResultComponentSessionActions = createActionGroup(
  {
    source: 'Pad Result Component Session',
    events: {
      Initialized: emptyProps(),
      'Load Session Redirect State Success': props<{
        payload: GetSessionRedirectStateV1Response;
      }>(),
      'Load Session Redirect State Error': props<{
        error: HttpErrorResponse;
      }>(),
    },
  },
);
